/**
 * Employee Web — `/me/hr-letters` list. UI lives in
 * `@linkhr/employee-self-service` (`MyLettersSection`); the route stays thin.
 *
 * `?get=<template code>&tax_year=<year>` deep-links into the catalogue (the
 * payroll tax-certificate modal lands here on TAX_CERTIFICATE); the section
 * consumes the params once and strips them.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MyLettersSection } from "@linkhr/employee-self-service";

export const Route = createFileRoute("/_auth/me/hr-letters/")({
  validateSearch: z.object({
    get: z.string().optional().catch(undefined),
    tax_year: z.string().optional().catch(undefined),
  }),
  component: MeHrLettersIndexRoute,
});

function MeHrLettersIndexRoute(): JSX.Element {
  return <MyLettersSection />;
}
